// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__OKi9S","header":"MergedInvoice_header__1gyaz"};